<template>
  <div>

    <div class="row mt-1 ml-0">
      <a class="btn-link smaller" href="#"
            @click="addCompany">
        <i class="fa fa-plus"></i> Add Company
      </a>
    </div>

    <el-table @cell-mouse-enter="rowHover" @cell-mouse-leave="rowHoverLeave"
              @row-click="rowClick"
              id="affiliateCompaniesTable" class="table-striped" 
              :data="affiliateCompanies" :row-class-name="rowClasses">

      <el-table-column prop="id" label="ID" width="100"/>

      <el-table-column label="Date created" width="140">
        <template slot-scope="{row}">
          {{ displayDate(row.dateCreated) }}
        </template>
      </el-table-column>

      <el-table-column label="Name">
        <template slot-scope="{row}">
          {{ row && row.profile ? row.profile.companyName || '-' : '-' }}
        </template>
      </el-table-column>

      <el-table-column prop="status" label="Status" width="70"/>

      <el-table-column width="1">
        <template slot-scope="{row}">
          <div :affiliateCompanyId="row.id"/>
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import utils from '../../utils'
export default {
    name: 'Affiliate-Companies-Table',
    props: {
      // hidePosition:       {type: Boolean, default: false},
      // hideCompany:        {type: Boolean, default: false},
      // hideLeadsReceived:  {type: Boolean, default: false},
      // hideLeadsClosed:    {type: Boolean, default: false},
      // hideLeads:          {type: Boolean, default: false},
      // hidePayouts:        {type: Boolean, default: false},
      // hideCloseRate:      {type: Boolean, default: false},
      // forCompany:         {type: Object, default: null}
    },
    mounted () {
      this.$store.dispatch('fetchBaseData')
    },
    computed: {
      affiliateCompanies () {
        return this.$store.getters.affiliateCompanies || []
      }
    },
    methods: {
      displayDate (date) {
        return utils.dateToString(date)
        // return '-'
      },
      addCompany () {
        alert(`Not yet implemented`)
      },

      rowClasses ({row, rowIndex}) {
        return row.archived?'archivedTableRow clickableRow':'clickableRow'
      },
      rowHover(row, column, cell, event) {
        // We show all buttons of class .showOnHover
        var rows = $('#affiliateCompaniesTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var foundRow = JSON.stringify($(rows[i]).html().indexOf('affiliateCompanyId="'+row.id+'"')) > -1
          var archivedRow = $(rows[i]).attr('class').indexOf('archivedTableRow') > -1
          if (foundRow && !archivedRow) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).removeClass('d-none')
            }
            break
          }
        }
      },
      rowHoverLeave (row, column, cell, event) {
        // We hide all buttons of class .showOnHover
        var rows = $('#affiliateCompaniesTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var index = JSON.stringify($(rows[i]).html().indexOf('affiliateCompanyId="'+row.id+'"'))
          if (index > -1) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).addClass('d-none')
            }
            break
          }
        }
      },
      rowClick (row, column, event) {
        // We check to see if the click happened on an icon button
        // var match = JSON.stringify(event.toElement.classList.value).match(/fa[rsdl]{0,1}\sfa-/i)
        var path = event.path || event.composedPath() // 2nd one if for Firefox
        var match = JSON.stringify(path[0].className).match(/fa[rsdl]{0,1}\sfa-/i)
        if (match && match.index > -1) {
          // icon button, we ignore row click
        } else {
          //console.log('row click')
          this.editAffiliateCompany(row)
        }
      }
    }
}
</script>

<style>
.el-table__row .cell {
  padding: 0;
}
.has-gutter .is-leaf .cell {
  padding: 0;
}
</style>